import { Flame, Phone } from "lucide-react";
import { Reveal } from "../Reveal";
import { LeadForm } from "../LeadForm";
import { SITE } from "../../lib/site";

export const FinalCta = () => (
  <section id="contact" data-testid="final-cta-section" className="relative py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-12 overflow-hidden scroll-mt-20">
    <div className="absolute -bottom-48 left-1/2 -translate-x-1/2 w-[700px] h-[500px] rounded-full bg-violet-600/15 blur-[150px] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <Reveal className="lg:col-span-6 space-y-6">
        <span
          data-testid="urgency-badge"
          className="inline-flex items-center gap-2 text-xs font-semibold text-amber-300 bg-amber-400/10 border border-amber-400/25 rounded-full px-4 py-1.5"
        >
          <Flame size={14} />
          Only 3 strategy-call slots left this month
        </span>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.1]">
          Ready To Turn Ad Spend Into{" "}
          <span className="gradient-accent-text">Revenue?</span>
        </h2>
        <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-lg">
          Every week you wait, your competitors buy the attention of your customers.
          One free call is all it takes to find out what's leaking in your funnel.
        </p>
        <div className="flex flex-wrap items-center gap-4 pt-2">
          <a
            data-testid="final-cta-call-button"
            href={`tel:${SITE.phoneRaw}`}
            className="inline-flex items-center gap-2.5 border border-white/15 rounded-full px-5 py-3 text-sm font-semibold text-white hover:border-cyan-400/50 transition-colors duration-200"
          >
            <Phone size={16} className="text-cyan-400" />
            Or call us now: {SITE.phone}
          </a>
        </div>
        <ul className="text-xs text-slate-500 space-y-1.5 pt-2">
          <li>— No obligation, no pushy sales pitch</li>
          <li>— Walk away with actionable advice either way</li>
        </ul>
      </Reveal>
      <Reveal className="lg:col-span-6" delay={0.15}>
        <div className="relative">
          <div className="absolute -inset-px rounded-3xl bg-gradient-to-br from-violet-500/50 via-transparent to-blue-500/50 pointer-events-none" />
          <LeadForm formId="final-lead-form" prefix="footer" />
        </div>
      </Reveal>
    </div>
  </section>
);
